import React from 'react';

import get from 'lodash/get';

import { Grid } from '@gogame/components';
import { FormFieldGroup } from '@gogame/form';

import FieldByType from './FieldByType';
import FieldSetArray from './FieldSetArray';
import { TYPE_ARRAY, TYPE_OBJECT } from './constants';

const FieldSetBySchema = ({ name, properties, definitions }) => {
  if (!properties) {
    return (
      <Grid item xs={12}>
        -
      </Grid>
    );
  }

  return Object.keys(properties).map((propertyName, i, array) => {
    const { description, type, items: itemsProps } = properties[propertyName];

    const items = itemsProps?.$ref
      ? get(definitions, itemsProps?.$ref.replace(/#\/|definitions\//g, ''))
      : itemsProps;

    if (type === TYPE_ARRAY && items?.type === TYPE_OBJECT) {
      return (
        <FormFieldGroup name={propertyName} key={i}>
          <FieldSetArray
            name={`${name}.${propertyName}`}
            description={description}
            {...items}
          />
        </FormFieldGroup>
      );
    }
    let xs = array.length > 2 ? 4 : 8;

    if (i === 0) {
      xs = array.length === 1 && items ? 12 : 4;
    }

    if (type === TYPE_ARRAY) {
      xs = 12;
    }

    return (
      <Grid item xs={xs} key={i}>
        <FieldByType
          name={propertyName}
          label={description}
          type={type}
          items={items}
          padding={0}
        />
      </Grid>
    );
  });
};

export default FieldSetBySchema;
